import {skipToken} from '@reduxjs/toolkit/query';
import {Text} from 'platform/foundation';

import {defaultTo, isNil} from 'ramda';

import {useGetUserQuery} from '@dms/api/customer';
import {getUserName} from '@dms/shared';

import {EMPTY_PLACEHOLDER, Nullish, RequiredTestIdProps} from 'shared/web';

interface UserNameProps extends RequiredTestIdProps {
  userId: string | Nullish;
}

export function UserName(props: UserNameProps) {
  const {data: user} = useGetUserQuery(isNil(props.userId) ? skipToken : {id: props.userId});

  return (
    <Text size="xSmall" data-testid={props['data-testid']}>
      {defaultTo(EMPTY_PLACEHOLDER, getUserName(user))}
    </Text>
  );
}
